<template>
  <m-input-select
    fullwidth
    :label="this.$t('common.integration')"
    :loading="integrationsMeta.loading"
    :options="integrationOptions"
    :value="value"
    @input="handleIntegrationSelect"
  />
</template>

<script>
  import { MInputSelect } from 'codefabrik-gui-vue'
  import { useIntegrations } from '@/views/integrations/integrationHooks'

  export default {
    name: 'IntegrationSelect',
    components: { MInputSelect },
    props: {
      value: {
        type: String,
        default: null
      },
      nullable: {
        type: Boolean,
        default: false
      },
    },
    mixins: [
      useIntegrations('integrations'),
    ],
    computed: {
      nullOption () {
        return { value: null, label: this.$t('common.all') }
      },
      integrationOptions () {
        const options = this.integrations.map(it => {
          return { value: it.id, label: it.name }
        })
        if (this.nullable) {
          return [this.nullOption, ...options]
        } else {
          if (this.value == null && options.length > 0) {
            this.handleIntegrationSelect(options[0].value)
          }
          return options
        }
      },
    },
    methods: {
      handleIntegrationSelect (newValue) {
        this.$emit('input', newValue)
      }
    }
  }
</script>

<style scoped>

</style>
